import React from 'react'

import { REVEAL_METERS, type RevealMeterId } from 'features/customers/constants/apiMeters'
import RevealUsageQuota from 'features/reveal/components/RevealUsageQuota'
import { type RevealCustomer, useRevealCustomers } from 'features/reveal/hooks/useRevealCustomers'
import { UrlProvider } from 'urls'

import { LabelWithTooltip } from 'components/_base'
import Table from 'components/table/Table'
import type { ColumnConfig } from 'components/table/types'

const meter = (id: RevealMeterId) => (
  <LabelWithTooltip label={REVEAL_METERS[id].label} tooltip={REVEAL_METERS[id].description} />
)

const config: ColumnConfig<RevealCustomer>[] = [
  {
    title: 'ID',
    field: 'id',
    headerStyle: { width: '100px' },
  },
  {
    title: 'Customer ID',
    field: 'customerId',
    headerStyle: { width: '150px' },
  },
  {
    title: 'Customer Name',
    field: 'name',
  },
  {
    title: meter('requests'),
    render: ({ requestQuota, requestQuotaUsage }) => (
      <RevealUsageQuota quota={requestQuota} usage={requestQuotaUsage} />
    ),
  },
  {
    title: meter('identified'),
    render: ({ identifiedQuota, identifiedQuotaUsage }) => (
      <RevealUsageQuota quota={identifiedQuota} usage={identifiedQuotaUsage} />
    ),
  },
  {
    title: meter('uniqueIdentifiedIps'),
    render: ({ uniqueIdentifiedIpsQuota, uniqueIdentifiedIpsQuotaUsage }) => (
      <RevealUsageQuota quota={uniqueIdentifiedIpsQuota} usage={uniqueIdentifiedIpsQuotaUsage} />
    ),
  },
  {
    title: meter('uniqueIdentifiedCompanies'),
    render: ({ totalIdentified }) => totalIdentified.toLocaleString(),
  },
  {
    title: 'Created At',
    field: 'createdAt',
  },
]

const RevealUsageOverview = () => {
  const { data, isLoading, error } = useRevealCustomers()

  return (
    <Table
      config={config}
      data={data}
      error={error ? 'Error occurred when loading Reveal API usage' : undefined}
      getRowLink={({ customerId }) => UrlProvider.getUrl('customer', { id: customerId, tab: '' })}
      hover
      loading={isLoading}
      title="Reveal API Usage"
    />
  )
}

export default RevealUsageOverview
